import React from "react";

// Small corner badge marking a nav-bar button as an AI feature. Styled after
// BetaTag.jsx (same shape, sibling file) but placed at the opposite corner
// (top-left) and in the pill's own violet palette, so it never collides with
// an existing Beta badge (top-right) on the same button.
export default function AiTag() {
  return (
    <span
      style={{
        position: "absolute",
        top: 1,
        left: 1,
        padding: "0 3px",
        borderRadius: 3,
        fontSize: 7,
        fontWeight: 700,
        letterSpacing: "0.04em",
        textTransform: "uppercase",
        lineHeight: "11px",
        background: "#EDE9FE",
        color: "#6D28D9",
        border: "1px solid #DDD6FE",
        zIndex: 2,
        pointerEvents: "none",
      }}
    >
      AI
    </span>
  );
}
